import MuiSkeleton from "@mui/material/Skeleton";
import type { SkeletonProps as MuiSkeletonProps } from "@mui/material/Skeleton";
import type { ElementType, ReactNode } from "react";

export interface SkeletonProps extends Omit<MuiSkeletonProps, "component"> {
  loading?: boolean;
  children?: ReactNode;
  component?: ElementType;
}

export function Skeleton({ variant, animation, loading, component, sx, children }: SkeletonProps) {
  if (children) {
    if (!loading) {
      return children;
    }

    return (
      <MuiSkeleton
        variant={variant}
        animation={animation}
        component={component as ElementType}
        sx={sx}
      >
        {children}
      </MuiSkeleton>
    );
  }

  return (
    <MuiSkeleton
      variant={variant}
      animation={animation}
      component={component as ElementType}
      sx={sx}
    />
  );
}
